/**
 * Boxes shared between the course page's loaded blocks and its skeleton
 * (`CourseDetailSkeleton.tsx`), so a pending page is the loaded page's shape
 * at every width. A `.ts` sibling so every component file here still exports
 * only a component (Fast Refresh) — the same split `course-card-box.ts` and
 * `faq-list-box.ts` make.
 */

/**
 * rest:ln (owner L1, mock `ln-detail`): the page's two columns — the course, and its buy card
 * IN the page (the rail is gone), 360 wide and 32 off the course, level with the course's badge.
 * Below `@4xl` the card is not drawn and `CourseCtaBar` holds the way in at the window's foot.
 */
export const DETAIL_COLUMNS =
  'grid grid-cols-1 gap-8 @4xl:grid-cols-[minmax(0,1fr)_--spacing(90)] @4xl:items-start'

/** The buy card's column: drawn from `@4xl`, where it stands beside the course. */
export const DETAIL_ASIDE = 'hidden @4xl:block'

/** The buy card (mock `ln-buy`): the course photo full bleed over 20 of price and actions. */
export const CTA_CARD = 'flex flex-col overflow-hidden rounded-lg bg-card text-card-foreground'

export const CTA_BODY = 'flex flex-col gap-4 p-5'
